// extracted by mini-css-extract-plugin
export default {"survey_box":"index_survey_box_sSqbb clearfix"};